import * as React from 'react';
import { arrayOf, bool, element, func, oneOfType } from 'prop-types';

export default class ErrorBoundary extends React.Component {
  static propTypes = {
    children: oneOfType([element, arrayOf(element)]),
    openContactDialog: func,
    nightModeEnabled: bool
  };

  state = {
    error: null
  };

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ marginLeft: 35, color: this.props.nightModeEnabled ? '#ffffff' : '#000000' }}>
          <p style={{ fontSize: '2.5em', marginBottom: 5 }}>Oops!</p>
          <p>
            Something went wrong. Try{' '}
            <span
              style={{ textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => window.location.reload()}
            >
              reloading the page
            </span>
            , or{' '}
            <span
              style={{ textDecoration: 'underline', cursor: 'pointer' }}
              onClick={this.props.openContactDialog}
            >
              submit an error report
            </span>{' '}
            if that doesn{"'"}t help.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
